import { useState } from 'react'

import { F0Dialog } from '@factorialco/f0-react'
import { NotVoid } from 'lodash'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import useAddMembersToPermissionGroup from 'modules/permissions/hooks/useAddMembersToPermissionGroup'
import type PermissionGroup from 'modules/permissions/store/models/PermissionGroup'

interface Props {
  onClose: () => NotVoid
  permissionGroup: PermissionGroup
  external: boolean
  excludeIds: number[]
}

const AssignUsersModal = ({ permissionGroup, onClose, excludeIds, external }: Props) => {
  const [accessIds, setAccessIds] = useState<number[]>([])
  const [addMembers, addingMembers] = useAddMembersToPermissionGroup()

  const submitDisabled = accessIds.length === 0 || addingMembers

  const onSubmit = async () => {
    await addMembers({
      permissionGroupId: permissionGroup.id,
      accessIds: accessIds,
    })
    onClose()
  }

  const title = external
    ? i18n.t('settings.permissions.group.actions.assign_users.title')
    : i18n.t('settings.permissions.group.actions.assign_employees.title')
  const description = external
    ? i18n.t('settings.permissions.group.actions.assign_users.description')
    : i18n.t('settings.permissions.group.actions.assign_employees.description')

  return (
    <F0Dialog
      isOpen
      width="sm"
      title={title}
      description={description}
      onClose={onClose}
      primaryAction={{
        label: i18n.t('common.save'),
        onClick: onSubmit,
        disabled: submitDisabled,
        loading: addingMembers,
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
      }}
    >
      <EmployeeSelectorV2
        multiple
        onChange={(state) => {
          if (state.type === 'manual') {
            setAccessIds(state.ids)
          }
        }}
        forcedFilters={{
          excludeIds: excludeIds,
        }}
        options={{
          hideLabel: true,
          asList: true,
          disableSelectAll: true,
        }}
        useAccessId
      />
    </F0Dialog>
  )
}

export default observer(AssignUsersModal)
